import { render, staticRenderFns } from "./editblog.vue?vue&type=template&id=e0f07268&scoped=true"
import script from "./editblog.vue?vue&type=script&lang=js"
export * from "./editblog.vue?vue&type=script&lang=js"
import style0 from "./editblog.vue?vue&type=style&index=0&id=e0f07268&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0f07268",
  null
  
)

export default component.exports